import { useGetTimberTypeQuery, useGetTimberTypePresentationQuery } from "../../../../timber/apis/TimberType.api";
import { TimberTypeNameDisplay } from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import { toString as toStringTimberType, PrimaryTimberType } from "../../../../timber/types/models/TimberType";
import * as crudgen from "../../../../share";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import { Button, IconButton, Stack, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { Add as AddIcon } from "@mui/icons-material";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";
import {ID} from "../../../../types/global.d";
import {useLocationFormState} from "./TimberTypeAddForm";
import TimberTypeAddFormProvider from "./TimberTypeAddFormProvider";

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {DescriptionAlert} from "../../../../share";
import { useFormContext } from 'react-hook-form';
import {useStateSession} from "../../../../hooks/useAuth";

const EMPTY_PAGINATION = {
    items: [],
    totalItems: 0,
    page: 0,
    pageSize: 12,
    numPages: 0
}

const AddDialog = ({name}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [showDialog, setShowDialog] = React.useState<boolean>(false)
    const {setValue} = useFormContext()

    return (
        <>
            <IconButton aria-label={ t`Add Timber Type` } onClick={() => setShowDialog(true)} size="small">
                <AddIcon />
            </IconButton>
            <Dialog
                open={showDialog}
                fullScreen={fullScreen}
                onClose={() => setShowDialog(false)}>
                <DialogTitle><Trans>Add Timber Type</Trans></DialogTitle>
                <DialogContent>
                    <DescriptionAlert/>
                    <TimberTypeAddFormProvider
                        successAction={
                            (data) => {
                                setValue(name, data.id)
                                setShowDialog(false)
                            }
                        }
                        cancelButton={<Button onClick={() => setShowDialog(false)}><Trans>Cancel</Trans></Button>}
                        initialFormState={useLocationFormState}
                        redirectPath="."
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}

const TimberTypeFormSelect = ({type, name, label, prefix, required, onValueChange, filter = {}} :
                                        {type: string, name: string, label: string, prefix: string, required: boolean, onValueChange?: (option: any) => void, filter: {
                                                name: string,
                                                }
                                        })  => {

    const session = useStateSession()
    const [, setInputTerm, inputTerm] = useSearchDebounce();

    const { data = EMPTY_PAGINATION,
        isLoading,
        isFetching,
    } = useGetTimberTypePresentationQuery({
      list: {
        page: 0,
        pageSize: 12,
      },
      filter: {
            name: inputTerm || '',
            nameOr: true,
            ...filter,
      },
    })

    if (type === 'select') {
        return (
            <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
                <crudgen.AsyncFormSelect
                   required={ required }
                   name={ prefix + name }
                   aria-label={ label }
                   label={ label }
                   optionsLoading={ isLoading || isFetching }
                   options={ data.items }
                   valueMap={ (id) => useGetTimberTypeQuery(PrimaryTimberType.fromId(id), {skip: !id}) }
                   optionLabelMap={ toStringTimberType }
                   onInputChange={ setInputTerm }
                   onValueChange={ onValueChange }
                   renderOption={ (optionProps, option, { inputValue }) => <li {...optionProps}><TimberTypeNameDisplay data={option}/></li> }
                />
                { session.hasPermission('', 'applications/timber/entities/TimberTypes/write/view') &&
                    <AddDialog name={name}/>
                }
            </Stack>
        )
    } else {
        return (
            <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
                <crudgen.AsyncFormSelect
                   required={ required }
                   name={ prefix + name }
                   aria-label={ label }
                   label={ label }
                   optionsLoading={ isLoading || isFetching }
                   options={ data.items }
                   valueMap={ (id) => useGetTimberTypeQuery(PrimaryTimberType.fromId(id), {skip: !id}) }
                   optionLabelMap={ toStringTimberType }
                   onInputChange={ setInputTerm }
                   onValueChange={ onValueChange }
                   renderOption={ (optionProps, option, { inputValue }) => <li {...optionProps}><TimberTypeNameDisplay data={option}/></li> }
                />
                { session.hasPermission('', 'applications/timber/entities/TimberTypes/write/view') &&
                    <AddDialog name={name}/>
                }
            </Stack>
        )
    }
}

export default TimberTypeFormSelect